import React, {useEffect, useState} from "react";
import Typography from '@mui/material/Typography';
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import Popover from '@mui/material/Popover';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export const IconInfo = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const idTooltip = open ? 'simple-popover' : undefined;

    return (
        <div>
            <a className="interactive-tooltip" onClick={handlePopoverOpen}>
                <InfoSharpIcon />
            </a>
            <Popover
                id={idTooltip}
                open={open}
                anchorEl={anchorEl}

                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}

                onClose={handlePopoverClose}
            >
                <div className="box-tooltip">
                    <div className="row">
                        <div className="col-12 bkg-deep-ocean d-flex align-items-center justify-content-end">
                            <a className="close-optional" onClick={handlePopoverClose}><CloseRoundedIcon style={{ color: 'white' }} /></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p className="text-tooltip">
                                {props.infoMessage}
                            </p>
                        </div>
                    </div>
                </div>
            </Popover>
        </div>

    );
};
export default IconInfo;